module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "Header"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/thanks",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Thanks")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/letter",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Letter to Readers")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("one")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SERENITY")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Joy")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Welcoming Angels")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("A Clear Midnight")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Let Us Spend One Day as Deliberately as Nature")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("An Ordinary Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("I Must Walk Again the Wooded Path")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Gift I Give Myself")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("When I Dance, I Dance")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Drop Thy Still Dews of Quietness")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Listen")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Be Still")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Mining the Heart")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter1#ch1-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Serenity Is Not")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("two")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAITH")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("When I’m Weary")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Angel Embrace")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Win or Lose, I Will Survive")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("You Must Believe")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Renewal")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Consolation")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Kaleidoscope of Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Let Nothing Disturb You")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#ch2-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Prayer for Protection")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("three")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COURAGE AND HOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Living in Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Contentment’s Recipe")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Climbing the Jade Mountain")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Building Bravery")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Yes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#ch3-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Seeds")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("four")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RELAXATION")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Sometimes, in a Summer Morning")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Let Your Soul Create a Sanctuary")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Windchimes")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("No Hurry")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Sanctuary")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("How the Rose Works")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#ch4-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Hammock")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("five")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFLECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Chasseurcistic")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The World We Make")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Success")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Forgiveness")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Is It So Small a Thing")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Passion")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Requiem for My Sister")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Lame Goat")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Of Consequence")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("It Will Pass")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Unconditional Dividends")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("I Saw That It Was Good")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Realizations")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Enigma")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Clouds That Pass")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#ch5-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Songs Along the Way")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("six")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOY AND GRATITUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Cup of Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Listen,")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Nevertheless;")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Humility")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Gravy")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Precious Moments")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Take Nothing for Granted")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Dawn’s Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("My Beautiful Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Going Through the Motions")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Gratitude")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("No Longer Forward nor Behind")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Invocation")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#ch6-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Everyday Blessings")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("seven")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAYERS")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Psalm for the Meaning of Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Live Quietly")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Poet’s Compline")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Hindu Prayer")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("A Prayer of Thanksgiving")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Prayer for Perspective")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("On This Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ch7-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("I Pray Today")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("eight")])])]), _vm._v(" "), _c('p', {
    staticClass: "Header3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INSPIRATION")])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("My Symphony")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Epiphany")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Way Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Tomorrow Is Not Promised")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Journey")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Writer’s Colony, Spring")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("I Can Believe in Fairies")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("As If Forever . . .")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("I Believe")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("It’s All Good")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("The Gift")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ch8-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Pippa’s Song")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Permissions and Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/about_the_author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "contents"
  }, [_c('span', {
    attrs: {
      "href": "#/also_by",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "black"
  }, [_vm._v("Also By June Cotner")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b12612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = 66
// module chunks = 0